import React from 'react';
import { Text } from '@podiumhq/design-system';

const TextMessageDisclaimer = () => {
  return (
    <Text color="grey.light" fontSize="sm" lineHeight="150%" maxWidth="400px">
      By clicking “Continue”, you authorize Podium to send text messages with
      offers and other information, including possibly using automated
      technology, to the mobile number provided. Message/data rates may apply.
      Consent is not a condition of purchase.
    </Text>
  );
};

export default TextMessageDisclaimer;
